const clientes = [
  {
    text: "Flavio Lopez",
    image: "/images/flaviolopez.png",
    url: "https://flaviolopez.com",
  },
  {
    text: "Abogados del Fuero",
    image: "/images/adf.png",
    url: "https://abogadosdelfuero.org.ar/",
  },
  {
    text: "Gondola Digital",
    image: "/images/gondoladigital.png",
    url: "https://gondola-digital.digitalpower.ar/",
  },
  {
    text: "Colegio Calasanz",
    image: "/images/calasanz.png",
    url: "https://colegiocalasanz.org/",
  },
  {
    text: "Red Oficios",
    image: "/images/oficios.png",
    url: "https://oficios.digitalpower.ar/",
  },
  {
    text: "Digital Power Stock",
    image: "/images/dpstock.png",
    url: "https://stock.digitalpower.ar",
  },
  {
    text: "JC Immigration Services",
    image: "/images/jcimm.png",
    url: "https://jcimmigrationservices.com",
  },
  {
    text: "Trading Sin Fronteras",
    image: "/images/tsf.png",
    url: "https://tradingsinfronteras.com",
  },
  {
    text: "Nueva Libreria",
    image: "/images/nl.png",
    url: "https://nuevalibreria.com.ar",
  },
  {
    text: "Papelera - La Fortaleza",
    image: "/images/papelera.png",
    url: "https://papeleralfortaleza.com.ar",
  },
  {
    text: "Distribuidora - La Fortaleza",
    image: "/images/fortaleza.png",
    url: "https://lafortaleza.com.ar",
  },
  {
    text: "Del sur inmobiliaria",
    image: "/images/delsur.png",
    url: "https://inmobiliaria-delsur.com.ar/propiedades",
  },
  {
    text: "Jeho Roller",
    image: "/images/jeho.png",
    url: "https://jehoroller.digitalpower.ar/",
  },
  {
    text: "Abogados San Miguel",
    image: "/images/abogados.png",
    url: "https://abogadossanmiguel.com.ar/",
  },
  {
    text: "Dos Santos Pereira",
    image: "/images/DSP.png",
    url: "https://dsp.corpresi.com/listaMayorista",
  },
  {
    text: "Template Interiores",
    image: "/images/interiores.png",
    url: "https://interiores.digitalpower.ar/",
  },
  {
    text: "Template Autos",
    image: "/images/ecommerce01.png",
    url: "https://ecommerce01.digitalpower.ar/",
  },
  {
    text: "Template Relojes",
    image: "/images/ecommerce02.png",
    url: "https://ecommerce02.digitalpower.ar/",
  },
];

export { clientes };
